import OverlayTrigger, { overlayPropTypes } from './OverlayTrigger.component';

export { overlayPropTypes };
export default OverlayTrigger;
